declare namespace $ {

	type $mol_text__text_invite_dict_1 = $mol_type_enforce<
		ReturnType< $invite_dict['transcription'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_labeler__title_invite_dict_2 = $mol_type_enforce<
		ReturnType< $invite_dict['word_label'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_invite_dict_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_search__query_invite_dict_4 = $mol_type_enforce<
		ReturnType< $invite_dict['word'] >
		,
		ReturnType< $mol_search['query'] >
	>
	export class $invite_dict extends $mol_page {
		word_label( next?: string ): string
		transcription( next?: string ): string
		Transcription( ): $mol_text
		Word( ): $mol_labeler
		word( next?: string ): string
		Search( ): $mol_search
		title( ): string
		Head( ): any
		api_uri( ): string
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=dict.view.tree.d.ts.map